export var MainGreen = '#08B273';
export var WarningRed = '#D83A68';
export var ReconnectionBlue = '#6DB1FF';
export var White = '#FFFFFF';
export var Opacity_16 = '#00000028';
export var Opacity_64 = '#000000A3';